<div class="wrapper flex flex-col">
  <div class="heading text-type-1 mb-[20px]">
    {{ errors ? 'Error' : 'Upload bid items' }}
  </div>
  <div *ngIf="errors" class="errors mb-[20px] text-type-14">
    <span class="flex flex-row justify-start items-center">
      <mat-icon class="error-icon mr-[8px]">error_outline</mat-icon>
      {{
        typeOf(errors) === 'string'
          ? errors
          : errors.length + ' issues were found. Re-upload the data after fixing the data on:'
      }}
    </span>
    <div *ngIf="typeOf(errors) !== 'string'" class="error-list ml-[33px]">
      <div class="each-error">
        <li *ngFor="let eachError of errors">
          <strong *ngIf="eachError.isRowError"
            >Row {{ eachError.rowNumber }} - Column {{ eachError.columnName }}: </strong
          >{{ eachError.msg }}
        </li>
      </div>
    </div>
  </div>
  <div class="template-section text-type-10 mb-[12px]">
    Upload bid items using a CSV or Excel file
  </div>
  <div class="file-upload-section">
    <div
      *ngIf="file"
      class="file-name flex flex-row justify-start items-center gap-[5px] mb-[12px] italic"
    >
      <span class="underline underline-offset-4">{{ file.name }}</span>
      <mat-icon (click)="removeSelectedFile()" class="close-icon mt-[5px]">close</mat-icon>
    </div>
    <div class="thumbnail-action-section flex flex-row gap-[1rem]">
      <button
        (click)="openFile('fileUploadRef')"
        class="upload-btn"
        color="primary"
        mat-stroked-button
      >
        Upload
      </button>
      <input
        #fileUploadRef
        (change)="handleFileUpload()"
        [id]="'fileUploadRef'"
        class="input-files"
        type="file"
      />
    </div>
  </div>
  <div class="actions mt-[calc(100px-1.25em)]">
    <app-primary-button
      (handleClick)="onSubmit()"
      [isDisabled]="!file || uploading"
    >
      {{ uploading ? 'Uploading...' : 'Submit' }}
    </app-primary-button>
  </div>
</div>
